import {
  GetActionsDocument,
  GetActionsQueryVariables,
  ProcessesAction,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useActions = (variables: GetActionsQueryVariables) => {
  const { data, loading } = useQuery(GetActionsDocument, {
    variables,
  })

  const actions: ProcessesAction[] =
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    (data?.processes?.actionsConnection.nodes as ProcessesAction[]) || []

  return {
    loading,
    actions,
  }
}
